<template>
  <div>
    <CJGG_HXS v-if="cityDetail.cityName === '辉县市' && $route.query.remark" />
    <CJGG_HJX
      v-else-if="cityDetail.cityName === '获嘉县' && $route.query.remark"
    />
    <CJGG_XCS
      v-else-if="cityDetail.cityName === '许昌市' && $route.query.remark"
    />
    <CJGG_DEFAULT v-else />
  </div>
</template>

<script>
import CJGG_DEFAULT from '@/components/成交公告详情_默认版本.vue'
import CJGG_HXS from '@/components/成交公告详情_辉县版本.vue'
import CJGG_XCS from '@/components/成交公告详情_许昌版本.vue'
import CJGG_HJX from '@/components/成交公告详情_获嘉版本.vue'
export default {
  components: {
    CJGG_DEFAULT,
    CJGG_HXS,
    CJGG_HJX,
    CJGG_XCS,
  },
}
</script>

<style lang="scss" scoped>
</style>